import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Input, Select } from 'antd'
import { useInvoice } from './hooks/useInvoice'
import Card from 'components/card/Card'
import NotFound from 'components/card/NotFound'
import Pagination from 'components/pagination/Pagination'
import { IconChecklistCircle, IconChevronDown, IconSearch } from 'components/icons'
import Errors from 'components/errors/Errors'
import InvoiceTable from './components/InvoiceTable'
import { DropdownInvoiceStatus } from 'constants/dropdown'
import { InvoiceFinanceSortFieldEnum } from 'generated/api'

function InvoiceIndex() {
  const invoiceHook = useInvoice()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.state && location.state.noInvoice && location.state.name) {
      invoiceHook.toast(
        `Nomor Invoice ${location.state.noInvoice} atas nama ${location.state.name} sudah dibayarkan.`,
        'success',
        <IconChecklistCircle color="white" />,
      )
    }
    invoiceHook.fetchData()
    navigate('/invoices/list', { replace: true })
  }, [
    invoiceHook.status,
    invoiceHook.page,
    invoiceHook.limit,
    invoiceHook.sortField,
    invoiceHook.sortBy,
  ])

  return (
    <div className="content-wrapper">
      {invoiceHook.toastContainer}
      <Card
        className="rounded-xl p-0 pb-2"
        spinnerTestId="loader_invoice"
        dataTestId="card_payment"
        loading={invoiceHook.loading}
      >
        <Card.Header className="block py-2 px-4">
          <div className="block xl:flex xl:h-12 h-fit">
            <div className="xl:w-2/5 w-full"></div>
            <div className="xl:w-3/5 w-full">
              <div className="xl:flex xl:flex-row xl:gap-4 h-full">
                <div className="xl:w-3/5 mb-4 xl:mb-0">
                  <Input
                    data-testid="input_invoice_number"
                    placeholder="Masukan Nomor Invoice"
                    className="input-search"
                    value={invoiceHook.invoiceNumber}
                    onChange={e => invoiceHook.setInvoiceNumber(e.target.value)}
                    onPressEnter={() => invoiceHook.handleSearchInvoice()}
                    suffix={<IconSearch />}
                  />
                </div>
                <div className="xl:w-2/5 mb-4 xl:mb-0">
                  <Select
                    data-testid="select_invoice_status"
                    value={invoiceHook.status}
                    onChange={value => invoiceHook.handleChangeStatus(value)}
                    placeholder="Semua Status"
                    className="selector w-full"
                    suffixIcon={<IconChevronDown />}
                  >
                    {DropdownInvoiceStatus.map(list => {
                      return (
                        <Select.Option
                          data-testid={'select_invoice_status_' + list.value}
                          key={list.key}
                          value={list.value}
                        >
                          {list.label}
                        </Select.Option>
                      )
                    })}
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="mt-0">
          {invoiceHook.failed ? (
            <Errors
              data-testid="error_invoice"
              inverse={false}
              header="Mohon maaf, permintaan Anda tidak dapat diproses."
              paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
              button={true}
              buttonLabel="Coba lagi"
              buttonAction={() => invoiceHook.fetchData()}
            />
          ) : (
            <>
              {invoiceHook.listInvoice.length === 0 ? (
                <NotFound message="Belum Ada Invoice" />
              ) : (
                <InvoiceTable
                  data={invoiceHook.listInvoice}
                  orderDirection={invoiceHook.sortBy}
                  orderColumn={invoiceHook.sortField}
                  setSortingOrder={(field: InvoiceFinanceSortFieldEnum) =>
                    invoiceHook.handleSort(field)
                  }
                />
              )}
            </>
          )}
        </Card.Body>
        {invoiceHook.totalRows > 10 && (
          <Card.Footer>
            <div className="px-4 py-3">
              <Pagination
                disabled={false}
                setLimit={(limit: number) => invoiceHook.handleChangeLimitInvoice(limit)}
                onPageChanged={(page: number) => invoiceHook.handleChangePageInvoice(page)}
                totalRows={invoiceHook.totalRows}
                currentPage={invoiceHook.page}
                limit={invoiceHook.limit}
                showLimitPage={true}
              />
            </div>
          </Card.Footer>
        )}
      </Card>
    </div>
  )
}

export default InvoiceIndex
